import gql from 'graphql-tag'
import { BasePriceFragment } from '@/graphql/fragments/sales'

export const mutation = gql`
  ${BasePriceFragment}
  mutation updateBonus($id: Int!,$fields: sales_bonus_set_input!) {
    record: update_sales_bonus_by_pk(pk_columns: {id: $id}, _set: $fields){
      ...Bonus
    }
  }
`

export default mutation
